import { ProductPreviewActionTypes } from '../../../enums/ActionEnums';
export const initialProductPreviewState = {
    imageTouchZoomHint: true,
};
export const productPreviewReducer = (state = initialProductPreviewState, action) => {
    switch (action.type) {
        case ProductPreviewActionTypes.UPDATE_IMAGE_TOUCH_ZOOM_HINT:
            return Object.assign(Object.assign({}, state), { imageTouchZoomHint: action.payload });
        default:
            return state;
    }
};
